export const tvshowList = [
  {
    id: "t-1",
    title: "长夜将明",
    year: 2025,
    region: "大陆",
    genres: ["悬疑", "犯罪"],
    rating: 8.8,
    popularity: 96300,
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20mystery%20drama%20series%20poster%20of%20a%20lone%20figure%20walking%20through%20a%20dim%20city%20under%20the%20first%20light%20of%20dawn%2C%20deep%20charcoal%20background%2C%20dramatic%20orange%20rim%20light%2C%20tense%20mood%2C%20minimal%20composition%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=tv-night-01&orientation=portrait",
    director: "江屿",
    cast: ["严澈", "白露", "宋辞"],
    episodes: 24,
    status: "更新中",
    summary: "一桩沉睡十二年的旧案重启，牵出整座城市不愿提起的往事。",
    synopsis:
      "十二年前的一场大火带走了三条生命，也让案件永久封存。新任刑警队长与当年唯一的幸存者联手重查，随着调查深入，他们发现真相与每个人的沉默息息相关。剧集以冷色调影像与多线叙事，呈现一段关于正义与代价的长夜。",
  },
  {
    id: "t-2",
    title: "未命名之城",
    year: 2024,
    region: "大陆",
    genres: ["剧情", "都市"],
    rating: 8.0,
    popularity: 67400,
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20urban%20drama%20series%20poster%20of%20a%20rooftop%20city%20skyline%20at%20night%20with%20a%20solitary%20person%20looking%20out%2C%20deep%20charcoal%20background%2C%20warm%20orange%20accents%2C%20contemplative%20mood%2C%20minimal%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=tv-city-02&orientation=portrait",
    director: "林岸",
    cast: ["许知遥", "陈亦", "阮清"],
    episodes: 36,
    status: "已完结",
    summary: "五个陌生人在同一栋写字楼里，把各自的人生重新排列。",
    synopsis:
      "在寸土寸金的城市中心，一栋写字楼里聚集着五个来自不同背景的普通人。升职、失恋、创业、离别，他们的故事在电梯与会议室之间交错展开。剧集用群像视角，描绘当代都市人的奋斗与温柔。",
  },
  {
    id: "t-3",
    title: "权力的边缘",
    year: 2025,
    region: "欧美",
    genres: ["剧情", "犯罪"],
    rating: 9.0,
    popularity: 102500,
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20prestige%20drama%20series%20poster%20of%20a%20chessboard%20on%20a%20dark%20marble%20table%20with%20a%20single%20fallen%20king%2C%20deep%20charcoal%20background%2C%20dramatic%20orange%20light%2C%20powerful%20mood%2C%20minimal%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=tv-power-03&orientation=portrait",
    director: "大卫·科恩",
    cast: ["托马斯·雷", "艾米丽·肖", "约瑟夫·凯"],
    episodes: 10,
    status: "更新中",
    summary: "一场选举背后，是层层叠叠的交易、背叛与野心。",
    synopsis:
      "在一座以港口闻名的城市，一场看似普通的选举将家族、财团与政客紧密捆绑。年轻的幕僚临危受命，试图在棋盘般的博弈中保持清醒。剧集以凌厉节奏与群像塑造，呈现权力光谱的每一道阴影。",
  },
  {
    id: "t-4",
    title: "宫廷秘史",
    year: 2023,
    region: "大陆",
    genres: ["古装", "剧情"],
    rating: 8.2,
    popularity: 72100,
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20historical%20palace%20drama%20series%20poster%20of%20an%20ornate%20palace%20corridor%20with%20lanterns%20and%20a%20silk-robed%20figure%2C%20deep%20charcoal%20background%2C%20warm%20orange%20lantern%20glow%2C%20elegant%20mood%2C%20minimal%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=tv-palace-04&orientation=portrait",
    director: "苏祁",
    cast: ["沈玉", "梁承", "温亦然"],
    episodes: 48,
    status: "已完结",
    summary: "深宫之中，一位不被看好的女子用智慧守住心中的道义。",
    synopsis:
      "少女入宫时只想安稳度日，却在风云变幻的朝局中一步步走到台前。她以冷静与仁心周旋于各方势力之间，最终揭开一桩尘封多年的冤案。剧集服化道考究，呈现一幅细腻的古代宫廷画卷。",
  },
  {
    id: "t-5",
    title: "笑到最后",
    year: 2024,
    region: "大陆",
    genres: ["喜剧", "都市"],
    rating: 7.5,
    popularity: 51800,
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20comedy%20series%20poster%20of%20bright%20colorful%20furniture%20in%20a%20cozy%20living%20room%2C%20deep%20charcoal%20background%2C%20warm%20orange%20accent%20light%2C%20playful%20upbeat%20mood%2C%20minimal%20composition%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=tv-comedy-05&orientation=portrait",
    director: "何欢",
    cast: ["马小乐", "孟甜", "周大伟"],
    episodes: 30,
    status: "已完结",
    summary: "一家濒临倒闭的喜剧剧场，五个不太靠谱的合伙人。",
    synopsis:
      "为了保住老板留下的老剧场，一群性格迥异的年轻人组成了史上最不靠谱的团队。他们用一场场笑料百出的演出，把生活里的狼狈变成舞台上的段子。温暖又搞笑的都市轻喜剧。",
  },
  {
    id: "t-6",
    title: "东京夜行",
    year: 2024,
    region: "日韩",
    genres: ["悬疑", "剧情"],
    rating: 8.4,
    popularity: 68900,
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20neo-noir%20series%20poster%20of%20a%20rainy%20Tokyo%20crossing%20at%20midnight%20with%20umbrellas%2C%20deep%20charcoal%20background%2C%20warm%20orange%20neon%20glow%2C%20mysterious%20mood%2C%20minimal%20composition%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=tv-tokyo-06&orientation=portrait",
    director: "中村慎",
    cast: ["高梨临", "佐野圣", "石田悠"],
    episodes: 12,
    status: "已完结",
    summary: "深夜的出租车司机，载着这座城市的秘密与孤独。",
    synopsis:
      "出租车司机徹每晚穿梭在东京的街巷，他遇见的每位乘客都带着一段未完的故事。一次偶然的搭载，让他被卷入一场关于寻找的旅程。剧集以夜色为幕，讲述都市中人与人之间短暂却温暖的连接。",
  },
  {
    id: "t-7",
    title: "未来边缘",
    year: 2025,
    region: "欧美",
    genres: ["科幻", "悬疑"],
    rating: 8.6,
    popularity: 81500,
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20sci-fi%20series%20poster%20of%20a%20sleek%20futuristic%20corridor%20with%20a%20human%20silhouette%20facing%20a%20glowing%20portal%2C%20deep%20charcoal%20background%2C%20orange%20energy%20light%2C%20tense%20mood%2C%20minimal%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=tv-future-07&orientation=portrait",
    director: "罗伯特·希尔",
    cast: ["凯特·莫宁", "亚当·福", "莉亚·兰"],
    episodes: 8,
    status: "更新中",
    summary: "当记忆可以被备份，谁还愿意为真实付出代价？",
    synopsis:
      "在不远的未来，人类可以将记忆上传至云端。一名记忆审计员在处理一份异常档案时，发现自己的过去也被悄悄改写过。为了找回真实的自我，他必须穿过层层加密的未来边缘。",
  },
  {
    id: "t-8",
    title: "家族风云",
    year: 2023,
    region: "港台",
    genres: ["剧情", "犯罪"],
    rating: 8.1,
    popularity: 59300,
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20family%20crime%20saga%20series%20poster%20of%20an%20elegant%20mansion%20dining%20table%20with%20empty%20chairs%2C%20deep%20charcoal%20background%2C%20dramatic%20orange%20chandelier%20light%2C%20dramatic%20mood%2C%20minimal%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=tv-family-08&orientation=portrait",
    director: "陈国栋",
    cast: ["李子豪", "何静怡", "张启明"],
    episodes: 40,
    status: "已完结",
    summary: "一场遗产争夺，让看似和睦的家族各怀心事。",
    synopsis:
      "老厂主离世后，偌大的家业与一纸遗书让三个子女站在了对立面。旧账、恩怨与未说出口的亲情在饭桌上层层摊开。剧集以家族群像呈现人性在利益前的挣扎与挽留。",
  },
  {
    id: "t-9",
    title: "青春协奏曲",
    year: 2022,
    region: "大陆",
    genres: ["都市", "喜剧"],
    rating: 7.3,
    popularity: 41200,
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20youth%20comedy%20series%20poster%20of%20a%20music%20band%20silhouette%20on%20a%20small%20stage%20with%20warm%20lights%2C%20deep%20charcoal%20background%2C%20orange%20glow%2C%20energetic%20mood%2C%20minimal%20composition%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=tv-youth-09&orientation=portrait",
    director: "温言",
    cast: ["孙一诺", "陆嘉", "冯小北"],
    episodes: 28,
    status: "已完结",
    summary: "五个大学生为了一场校园音乐节，报名了根本不存在的乐队。",
    synopsis:
      "为了赢得音乐节的门票，一群毫无乐器基础的同学临时组队。从跑调到登上舞台，他们在排练室里闹出无数笑话，也收获了最珍贵的友谊。一部轻松治愈的青春群像剧。",
  },
];